export const FEDERATED_SIGN_IN_STORE_KEY = 'federatedSignIn';

export const FEDERATED_SIGN_IN_GENERIC_ERROR_CODE = 'federated_sign_in_error';

// TODO i18n: double check if this is displayed anywhere and needs
export const ALREADY_FOUND_AN_ENTRY_ERROR_MSG = 'Already found an entry for username';

export const FEDERATED_SIGN_IN_SRC = {
  XERO_MARKETPLACE: 'xero marketplace'
};
